import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'dashboard_asi.my_contracts.title',
  },
  contractsAndGuarantees: {
    id: 'dashboard_asi.contracts_and_guarantees',
  },
  Actif: {
    id: 'dashboard_auto.mes_contracts.actif',
  },
  Encours: {
    id: 'dashboard_auto.mes_contracts.encours',
  },
  id: {
    id: 'dashboard_asi.contract.id',
  },
  policyNumber: {
    id: 'dashboard_asi.contract.policy_number',
  },
});
